
const NIMES = [
    {
      page: 2,
      lib: "Echauffement",
      texteIndice: ["La frise aide", "Indice sur les bords, les lettres", "Nîmes (enigmes moins ne n et g!)"]
    },
    {
      page: 4,
      lib: "L'homme",
      texteIndice: [
        "Un homme de pierre",
        "Une statue au mur",
        "33"
      ]
    },
    {
      page: 6,
      lib: "Réunion",
      texteIndice: [
        "Retrouvez l'autre morceau",
        "Sur le plan, pour retrouver au mur la figure",
        "Douze"
      ]
    },
    {
      page: 9,
      lib: "Détail",
      texteIndice: [
        "Pas la grille",
        "Une des fenêtres n'est pas visible",
        "Logement (cette image n'est pas sur cette place)"
      ]
    },
    {
      page: 11,
      lib: "La frise",
      texteIndice: [
        "Commencez par résoudre l'anagramme",
        "Gardez que les cranes de la façade",
        "Fils"
      ]
    },
    {
      page: 14,
      lib: "Le monstre",
      texteIndice: ["1ere étape, trouver la faience au mur", "Utilisez le soleil", "Par transparence de la page précédente", "Quatre"]
    },
    {
      page: 16,
      lib: "Chaussures",
      texteIndice: [
        "Jeanne d'Arc",
        "Cachée contre l'église, à l'extérieur",
        "Sabots"
      ]
    },
    {
      page: 18,
      lib: "Suite",
      texteIndice: [
        "Retrouvez sur le milieu de la façade la suite",
        "Plus qu'à remettre dans le bon ordre pour former mot ",
        "Volque"
      ]
    },
    {
      page: 20,
      lib: "Ballade",
      texteIndice: [
        "Fête des amoureux & statue",
        "La date de la St Valentin est le 14 février, utilisez base statue",
        "Vote"
      ]
    },
    {
      page: 22,
      lib: "Poésie",
      texteIndice: [
        "Le plafond à l'extérieur du temple",
        "C _ _ _ C",
        "C _ L _ C",
        "Coloc"
      ]
    },
    {
      page: 24,
      lib: "Rotation",
      texteIndice: [
        "Un question de vision, comparez avec le réel",
        "Un sens de lecture",
        "Annaba"
      ]
    },
    {
      page: 25,
      lib: "Le Signal",
      texteIndice: [
        "Le signal est une oeuvre sur la place",
        "Comme un avion ou un bateau il a des feux",
        "Sud-Est"
      ]
    },
    {
      page: 26,
      lib: "L'auteur",
      texteIndice: ["Trouvez le magasin", "Un ancienne façade avec Camus", "Tapissier"]
    },
    {
      page: 28,
      lib: "L'autre'",
      texteIndice: [
        "Trouvez l'hôtel",
        "Comparez plaque et page",
        "Rouge"
      ]
    },
    {
      page: 30,
      lib: "Animaux",
      texteIndice: ["Sur la fontaine", "Des pattes", "Oiseaux"]
    },
    {
      page: 31,
      lib: "Folie",
      texteIndice: [
        "Faite jouer la statue",
        "Aux échecs",
        "Serena"
      ]
    },
    {
      page: 99,
      lib_page: "Dernière étape - Vérifier la réponse à toute l'enquête !",
      lib: "Vous avez terminé le parcours ? Bravo ! Alors que donne l'enquête ?",
      lib_win_title: "Bravo ! Félicitations !",
      lib_win_texte: "Encore un grand merci d'avoir participé à l'un de nos jeux !",
      questions: ["Quel est le numéro du coupable ?", "Avec combien de mots raturés ?"],
      answers: [3,6]
    }
  ];

export default NIMES;